export default __webpack_public_path__ + "static/media/hyperfly.89a1e726.png";